module.exports = __webpack_public_path__ + "img/42.70fc4eb7.jpg";